const logout  = async ({
  set,
  get,
  opts: value,
}) => {
  set({ isFetching: true });
};

export default logout;
